module.exports = {"411330100":"城关镇","411330101":"月河镇","411330102":"吴城镇","411330103":"固县镇","411330104":"毛集镇","411330105":"大河镇","411330106":"埠江镇","411330107":"平氏镇","411330108":"淮源镇","411330109":"黄岗镇","411330110":"安棚镇","411330111":"朱庄镇","411330112":"程湾镇","411330300":"城郊乡","411330301":"回龙乡","411330306":"新集乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411330.json
// module id = 1649
// module chunks = 0